export enum ServicesReducerPath {
	ExamsApi = 'examsApi',
	CdaApi = 'cdaApi',
}

export enum ServicesApiTag {
	Cda = 'cda',
}
